/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { TRACKING: de },
  'en-US': { TRACKING: en },
  'es-ES': { TRACKING: es },
  'it-IT': { TRACKING: it },
  'pt-PT': { TRACKING: pt }
};
